const initPxlProductVariants = (root = document) => {
  const dropdowns = root.querySelectorAll('[data-flavor-dropdown]');

  dropdowns.forEach((dropdown) => {
    if (dropdown.dataset.pxlFlavorDropdownInitialized) {
      return;
    }

    dropdown.dataset.pxlFlavorDropdownInitialized = 'true';
    const toggle = dropdown.querySelector('.flavor-dropdown-pxl__toggle');
    const selectedWrap = dropdown.querySelector('.flavor-dropdown-pxl__selected');
    const options = [...dropdown.querySelectorAll('.flavor-dropdown-pxl__option')];
    if (!toggle) {
      return;
    }

    const syncCurrentOption = () => {
      const currentUrl = dropdown.dataset.currentUrl || window.location.pathname;
      const normalizedCurrentUrl = currentUrl.replace(/\/$/, '');

      let activeOption = options.find((option) => {
        const optionPath = new URL(option.href, window.location.origin).pathname.replace(/\/$/, '');
        return optionPath === normalizedCurrentUrl;
      });

      if (!activeOption) {
        activeOption = dropdown.querySelector('.flavor-dropdown-pxl__option.active') || options[0];
      }

      options.forEach((option) => {
        const isActive = option === activeOption;
        option.classList.toggle('active', isActive);
        if (isActive) {
          option.setAttribute('aria-current', 'page');
        } else {
          option.removeAttribute('aria-current');
        }
      });

      if (activeOption && selectedWrap) {
        selectedWrap.innerHTML = activeOption.innerHTML;
      }
    };

    const closeDropdown = () => {
      dropdown.removeAttribute('open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    syncCurrentOption();

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = dropdown.hasAttribute('open');
      document.querySelectorAll('[data-flavor-dropdown][open]').forEach((openDropdown) => {
        if (openDropdown !== dropdown) {
          openDropdown.removeAttribute('open');
          openDropdown.querySelector('.flavor-dropdown-pxl__toggle')?.setAttribute('aria-expanded', 'false');
        }
      });
      if (isOpen) {
        closeDropdown();
      } else {
        dropdown.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    dropdown.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDropdown();
        toggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown();
      }
    });
  });

  const subscriptionBoxes = root.querySelectorAll('[data-pxl-subscription]');

  subscriptionBoxes.forEach((box) => {
    if (box.dataset.pxlSubscriptionInitialized) {
      return;
    }

    box.dataset.pxlSubscriptionInitialized = 'true';
    const toggle = box.querySelector('[data-pxl-subscription-toggle]');
    const input = box.querySelector('[data-pxl-selling-plan-input]');
    const jsonEl = box.querySelector('[data-pxl-subscription-json]');
    const discountEl = box.querySelector('[data-pxl-subscription-discount]');
    const boxPriceEl = box.querySelector('[data-pxl-subscription-price]');
    const boxCompareEl = box.querySelector('[data-pxl-subscription-compare-price]');
    const recurringDiscountEl = box.querySelector('[data-pxl-recurring-subscription-discount]');
    const productPage = box.closest('product-page');
    const productVariants = productPage?.querySelector('product-variants[data-main-product-variants]');
    const priceRoot = productPage?.querySelector('[id^="product-price-"]');
    const priceOriginal = priceRoot?.querySelector('[data-js-product-price-original]');
    const priceCompare = priceRoot?.querySelector('[data-js-product-price-compare]');
    const priceDiscount = priceRoot?.querySelector('[data-save-text].product-price--discount');
    const addToCartText = productPage?.querySelector('[data-js-product-add-to-cart-text]');
    const linePackInput = productPage?.querySelector('[data-pxl-line-pack]');
    const lineSubscribeInput = productPage?.querySelector('[data-pxl-line-subscribe]');
    const unitPriceLabels = productPage ? [...productPage.querySelectorAll('[data-pxl-unit-price]')] : [];
    const appSellingPlanInputs = productPage
      ? [...productPage.querySelectorAll('.sealsubs-container [name="selling_plan"], .sealsubs-container [name="purchase_option"], .sealsubs-container select')]
      : [];
    let data = null;
    let isApplyingDisplay = false;

    try {
      data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (error) {
      data = null;
    }

    if (!toggle || !input || !data || !productVariants) {
      return;
    }

    appSellingPlanInputs.forEach((field) => {
      field.disabled = true;
    });

    const getCurrentVariantId = () => {
      if (productVariants.currentVariant?.id) {
        return String(productVariants.currentVariant.id);
      }
      const variantInput = productPage?.querySelector(`#product-form-${productVariants.dataset.id} input[name="id"]`);
      return variantInput ? String(variantInput.value) : null;
    };

    const updateDisplay = (variantIdOverride = null) => {
      if (isApplyingDisplay) {
        return;
      }
      const variantId = variantIdOverride || getCurrentVariantId();
      const variantData = variantId ? data.variants[variantId] : null;
      if (!variantData) {
        return;
      }

      isApplyingDisplay = true;

      const subscriptionActive = toggle.checked && variantData.subscriptionPrice;
      input.value = subscriptionActive ? variantData.sellingPlanId : '';
      input.disabled = !subscriptionActive;

      if (linePackInput) {
        linePackInput.value = variantData.linePack || '';
      }

      if (lineSubscribeInput) {
        lineSubscribeInput.value = subscriptionActive ? 'true' : 'false';
      }

      if (priceOriginal) {
        priceOriginal.textContent = subscriptionActive ? variantData.effectiveSubscriptionPriceFormatted : variantData.oneTimePriceFormatted;
      }

      if (priceCompare) {
        priceCompare.innerHTML = '';
        const compareText = subscriptionActive ? variantData.subscriptionCompareFormatted : variantData.oneTimeCompareFormatted;
        if (compareText) {
          priceCompare.innerHTML = `<span>${compareText}</span>`;
        }
      }

      if (discountEl) {
        discountEl.textContent = `${variantData.effectiveSubscriptionDiscountPercent || 0}%`;
      }

      const hasExtraDiscount = Number(variantData.effectiveSubscriptionDiscountPercent || 0) > 0;
      box.querySelectorAll('[data-pxl-extra-copy]').forEach((el) => { el.hidden = !hasExtraDiscount; });
      box.querySelectorAll('[data-pxl-plain-copy]').forEach((el) => { el.hidden = hasExtraDiscount; });

      if (boxPriceEl && variantData.effectiveSubscriptionPriceFormatted) {
        boxPriceEl.textContent = variantData.effectiveSubscriptionPriceFormatted;
      }
      if (boxCompareEl) {
        const boxCompareText = variantData.subscriptionCompareFormatted || variantData.oneTimePriceFormatted || '';
        const showBoxCompare = Boolean(boxCompareText) && boxCompareText !== variantData.effectiveSubscriptionPriceFormatted;
        boxCompareEl.hidden = !showBoxCompare;
        if (showBoxCompare) {
          boxCompareEl.textContent = boxCompareText;
        }
      }

      if (recurringDiscountEl) {
        recurringDiscountEl.textContent = `${variantData.recurringSubscriptionSavingsPercent || 0}%`;
      }

      unitPriceLabels.forEach((unitPriceLabel) => {
        const nextUnitPrice = subscriptionActive ? unitPriceLabel.dataset.subscriptionUnitPrice : unitPriceLabel.dataset.oneTimeUnitPrice;
        if (nextUnitPrice) {
          unitPriceLabel.textContent = nextUnitPrice;
        }
      });

      if (priceDiscount) {
        const savingsText = subscriptionActive ? variantData.subscriptionSavingsFormatted : variantData.oneTimeSavingsFormatted;
        const saveText = priceDiscount.dataset.saveText || '';
        if (savingsText) {
          priceDiscount.textContent = `${saveText} ${savingsText}`.trim();
          priceDiscount.style.display = 'inline-flex';
        } else {
          priceDiscount.textContent = '';
          priceDiscount.style.display = 'none';
        }
      }

      if (addToCartText) {
        const nextPrice = subscriptionActive ? variantData.effectiveSubscriptionPriceFormatted : variantData.oneTimePriceFormatted;
        if (productVariants.currentVariant?.available && nextPrice) {
          addToCartText.innerHTML = `${KROWN.settings.locales.products_add_to_cart_button}<span class="button__price"> - ${nextPrice}</span>`;
        }
      }

      window.setTimeout(() => {
        isApplyingDisplay = false;
      }, 0);
    };

    const scheduleDisplayRefresh = (variantIdOverride = null) => {
      const refresh = () => updateDisplay(variantIdOverride || getCurrentVariantId());
      refresh();
      window.setTimeout(refresh, 30);
      window.setTimeout(refresh, 120);
      window.setTimeout(refresh, 250);
    };

    if (typeof productVariants.updatePrice === 'function' && !productVariants.dataset.pxlSubscriptionPricePatched) {
      const originalUpdatePrice = productVariants.updatePrice.bind(productVariants);
      productVariants.updatePrice = () => {
        originalUpdatePrice();
        scheduleDisplayRefresh(productVariants.currentVariant?.id ? String(productVariants.currentVariant.id) : null);
      };
      productVariants.dataset.pxlSubscriptionPricePatched = 'true';
    }

    toggle.addEventListener('change', () => {
      scheduleDisplayRefresh();
    });
    productVariants.addEventListener('VARIANT_CHANGE', (event) => {
      const nextVariantId = event?.target?.currentVariant?.id ? String(event.target.currentVariant.id) : null;
      scheduleDisplayRefresh(nextVariantId);
    });
    productVariants.querySelectorAll('.product-variant-value, .product-variant__input, select[data-js-product-variant-container="select"], [data-js-product-variant-container="radio"] input').forEach((field) => {
      field.addEventListener('change', () => {
        scheduleDisplayRefresh();
      });
    });

    if (priceRoot) {
      const priceObserver = new MutationObserver(() => {
        if (!isApplyingDisplay) {
          scheduleDisplayRefresh();
        }
      });
      priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    if (addToCartText) {
      const addToCartObserver = new MutationObserver(() => {
        if (!isApplyingDisplay) {
          scheduleDisplayRefresh();
        }
      });
      addToCartObserver.observe(addToCartText, { childList: true, subtree: true, characterData: true });
    }

    scheduleDisplayRefresh();
  });

  const pxlFlavorModals = [...document.querySelectorAll('.modal--pxl-flavors')];

  pxlFlavorModals.forEach((modal) => {
    if (modal.dataset.pxlDragCloseInitialized) {
      return;
    }

    modal.dataset.pxlDragCloseInitialized = 'true';

    const handle = modal.querySelector('.modal-close');
    const content = modal.querySelector('.modal-content');
    if (!handle || !content) {
      return;
    }
    const dragSurface = content;

    let startY = 0;
    let lastY = 0;
    let startTime = 0;
    let isDragging = false;
    let suppressClick = false;

    const resetDragStyles = () => {
      content.style.transition = '';
      content.style.transform = '';
      modal.style.background = '';
    };

    const closeModal = () => {
      resetDragStyles();
      if (typeof modal.hide === 'function') {
        modal.hide(modal.o?.showOnce);
        return;
      }

      handle.click();
    };

    dragSurface.addEventListener('pointerdown', (event) => {
      if (!modal.classList.contains('active')) {
        return;
      }

      startY = event.clientY;
      lastY = startY;
      startTime = performance.now();
      isDragging = true;
      suppressClick = false;
      content.style.transition = 'none';
      dragSurface.setPointerCapture?.(event.pointerId);
    });

    dragSurface.addEventListener('pointermove', (event) => {
      if (!isDragging) {
        return;
      }

      const dragDistance = Math.max(0, event.clientY - startY);
      lastY = event.clientY;

      if (dragDistance < 4) {
        return;
      }

      event.preventDefault();
      suppressClick = true;
      content.style.transform = `translateY(${dragDistance}px)`;
      modal.style.background = `rgba(0, 0, 0, ${Math.max(0.25, 0.7 - dragDistance / 450)})`;
    });

    const endDrag = (event) => {
      if (!isDragging) {
        return;
      }

      const dragDistance = Math.max(0, lastY - startY);
      const elapsed = Math.max(1, performance.now() - startTime);
      const velocity = dragDistance / elapsed;
      isDragging = false;
      dragSurface.releasePointerCapture?.(event.pointerId);

      if (dragDistance > 85 || (dragDistance > 38 && velocity > 0.45)) {
        closeModal();
        return;
      }

      content.style.transition = 'transform 180ms ease';
      content.style.transform = '';
      modal.style.background = '';
      window.setTimeout(() => {
        content.style.transition = '';
      }, 190);
    };

    dragSurface.addEventListener('pointerup', endDrag);
    dragSurface.addEventListener('pointercancel', endDrag);
    dragSurface.addEventListener('lostpointercapture', endDrag);

    dragSurface.addEventListener('click', (event) => {
      if (!suppressClick) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
  });

  const productPages = root.matches?.('product-page') ? [root] : [...root.querySelectorAll('product-page')];

  productPages.forEach((productPage) => {
    if (productPage.dataset.pxlGalleryInitialized) {
      return;
    }

    const productVariants = productPage.querySelector('product-variants[data-main-product-variants]');
    const productGallery = productPage.querySelector('[data-js-product-gallery]');
    const productSlider = productGallery?.querySelector('css-slider');
    const mediaItems = productGallery ? [...productGallery.querySelectorAll('.product-gallery-item[data-media-id]')] : [];
    const flavorsPopup = document.getElementById(`pxl-flavors-popup-${productVariants?.dataset.id}`);
    const flavorsPopupImage = flavorsPopup?.querySelector('[data-pxl-flavors-popup-image]');
    const flavorsPopupContent = flavorsPopup?.querySelector('[data-pxl-flavors-popup-content]');

    if (!productVariants || !productGallery || mediaItems.length < 1) {
      return;
    }

    const shouldWaitForSliderMarkup = productSlider
      && window.matchMedia('(max-width: 1023px)').matches
      && !productSlider.querySelector('.css-slider-container');

    if (shouldWaitForSliderMarkup) {
      window.setTimeout(() => initPxlProductVariants(productPage), 100);
      window.setTimeout(() => initPxlProductVariants(productPage), 300);
      return;
    }

    productPage.dataset.pxlGalleryInitialized = 'true';
    const galleryBindingId = `${Date.now()}-${Math.random()}`;
    productPage.dataset.pxlGalleryBindingId = galleryBindingId;
    const isCurrentGalleryBinding = () => productPage.dataset.pxlGalleryBindingId === galleryBindingId;
    const variantMediaSlot = productGallery.querySelector('[data-pxl-variant-media-slot]') || mediaItems[0];
    const firstImageBadge = productGallery?.querySelector('.pxl-first-image-badge');
    const firstImageBadgeParent = firstImageBadge?.parentElement;
    const firstImageBadgeNextSibling = firstImageBadge?.nextSibling || null;
    let galleryFadeTimeout = null;
    let galleryPromotionTimeout = null;
    let variantMediaMap = {};
    let variantData = [];
    let lastGalleryMode = window.matchMedia('(max-width: 1023px)').matches ? 'slider' : 'grid';
    let lastSliderMarkupState = Boolean(productGallery.querySelector('.css-slider-container'));
    let resizeRebindTimeout = null;

    try {
      variantMediaMap = JSON.parse(productPage.querySelector('[data-pxl-variant-media-map]')?.textContent || '{}') || {};
    } catch (error) {
      variantMediaMap = {};
    }

    try {
      variantData = JSON.parse(productVariants.querySelector('script[type="application/json"]')?.textContent || '[]') || [];
    } catch (error) {
      variantData = [];
    }

    const getSelectedVariantFromInputs = () => {
      const selectedOptions = [];

      productVariants.querySelectorAll('[data-js-product-variant]').forEach((variantGroup) => {
        const container = variantGroup.querySelector('[data-js-product-variant-container]');

        if (!container) {
          return;
        }

        if (container.dataset.jsProductVariantContainer === 'radio') {
          const checkedInput = container.querySelector('.product-variant__input:checked');
          if (checkedInput) {
            selectedOptions.push(checkedInput.value);
          }
          return;
        }

        if (container.value) {
          selectedOptions.push(container.value);
        }
      });

      if (!selectedOptions.length) {
        return productVariants.currentVariant;
      }

      return variantData.find((variant) => {
        return !variant.options.map((option, index) => selectedOptions[index] === option).includes(false);
      }) || productVariants.currentVariant;
    };

    const getSelectedPackValue = () => {
      const packVariantGroup = [...productVariants.querySelectorAll('[data-js-product-variant]')].find((variantGroup) => {
        return (variantGroup.dataset.name || '').includes('pack');
      });

      const checkedPackInput = packVariantGroup?.querySelector('.product-variant__input:checked');
      if (checkedPackInput?.value) {
        return checkedPackInput.value;
      }

      const selectedVariant = getSelectedVariantFromInputs();
      return selectedVariant?.options?.find((option) => /pack/i.test(option)) || null;
    };

    const updateFlavorsPopupContent = () => {
      if (!flavorsPopup) {
        return;
      }

      const selectedPackValue = getSelectedPackValue();
      const selectedContentTemplate = selectedPackValue
        ? flavorsPopup.querySelector(`template[data-pxl-flavors-popup-template="${selectedPackValue}"]`)
        : null;
      const selectedImageTemplate = selectedPackValue
        ? flavorsPopup.querySelector(`template[data-pxl-flavors-popup-image-template="${selectedPackValue}"]`)
        : null;

      if (flavorsPopupContent && selectedContentTemplate?.innerHTML.trim()) {
        flavorsPopupContent.innerHTML = selectedContentTemplate.innerHTML;
      }

      if (flavorsPopupImage && selectedImageTemplate) {
        flavorsPopupImage.innerHTML = selectedImageTemplate.innerHTML;
      }
    };

    const isDesktopGridGallery = () => {
      const slider = productGallery.querySelector('css-slider');
      return window.matchMedia('(min-width: 1024px)').matches
        && productGallery.classList.contains('product-gallery--scroll')
        && !slider?.sliderEnabled;
    };

    const resetMediaOrder = () => {
      mediaItems.forEach((mediaItem) => {
        mediaItem.style.removeProperty('order');
        mediaItem.classList.remove('pxl-variant-media-first');
      });
    };

    const getSizedImageUrl = (src, width) => {
      if (!src || !width) {
        return src;
      }

      try {
        const imageUrl = new URL(src, window.location.origin);
        imageUrl.searchParams.set('width', width);
        return imageUrl.toString();
      } catch (error) {
        return src;
      }
    };

    const getVariantImageState = (variant) => {
      const mappedImage = variant?.id ? variantMediaMap[String(variant.id)] : null;

      if (mappedImage?.src) {
        return mappedImage;
      }

      const featuredMedia = variant?.featured_media || null;
      const featuredImage = variant?.featured_image || variant?.image || null;
      const previewImage = featuredMedia?.preview_image || featuredImage || featuredMedia;
      const src = previewImage?.src || featuredImage?.src || featuredMedia?.src || (typeof featuredImage === 'string' ? featuredImage : '');
      const mediaId = featuredMedia?.id || featuredImage?.id || previewImage?.id;

      if (!src) {
        return null;
      }

      const widths = [240, 360, 420, 480, 640, 840, 1080, 1280].filter((width) => !previewImage.width || width <= previewImage.width);

      return {
        mediaId: mediaId ? String(mediaId) : variantMediaSlot.dataset.mediaId,
        src: getSizedImageUrl(src, 840),
        srcset: widths.length ? widths.map((width) => `${getSizedImageUrl(src, width)} ${width}w`).join(', ') : '',
        width: previewImage.width || featuredMedia?.width || featuredImage?.width,
        height: previewImage.height || featuredMedia?.height || featuredImage?.height,
        alt: featuredMedia?.alt || featuredImage?.alt || variant.name || variant.title || '',
      };
    };

    const applyVariantMediaTemplate = (variant) => {
      if (!variantMediaSlot || !variant?.id) {
        return false;
      }

      const template = productPage.querySelector(`template[data-pxl-variant-media-template="${variant.id}"]`);
      const templateMedia = template?.content?.querySelector('.product-gallery-item');

      if (!templateMedia) {
        return false;
      }

      const slotIndex = variantMediaSlot.dataset.index || '0';
      const sliderClasses = [...variantMediaSlot.classList].filter((className) => className.startsWith('css-slide'));
      variantMediaSlot.innerHTML = templateMedia.innerHTML;
      variantMediaSlot.id = templateMedia.id;
      variantMediaSlot.dataset.productMediaType = templateMedia.dataset.productMediaType || 'image';
      variantMediaSlot.dataset.mediaId = templateMedia.dataset.mediaId || variantMediaSlot.dataset.mediaId;
      variantMediaSlot.dataset.video = templateMedia.dataset.video || '';
      variantMediaSlot.dataset.index = slotIndex;
      variantMediaSlot.dataset.pxlVariantMediaSlot = '';
      variantMediaSlot.setAttribute('tabindex', templateMedia.getAttribute('tabindex') || '0');

      if (templateMedia.hasAttribute('data-image-zoom')) {
        variantMediaSlot.setAttribute('data-image-zoom', '');
      } else {
        variantMediaSlot.removeAttribute('data-image-zoom');
      }

      if (templateMedia.dataset.ratio) {
        variantMediaSlot.dataset.ratio = templateMedia.dataset.ratio;
      }

      if (templateMedia.getAttribute('style')) {
        variantMediaSlot.setAttribute('style', templateMedia.getAttribute('style'));
      }

      sliderClasses.forEach((className) => variantMediaSlot.classList.add(className));
      variantMediaSlot.classList.add('product-gallery-item', 'element--border-radius');
      return true;
    };

    const resetSliderToVariantSlide = () => {
      const slider = productGallery.querySelector('css-slider');
      const refreshProductPageMediaCache = () => {
        productPage.productImageSlides = productGallery.querySelectorAll('.product-gallery-item');
        productPage.productImages = productGallery.querySelectorAll('.product-media-image');
      };

      if (slider?.sliderEnabled && typeof slider.changeSlide === 'function') {
        refreshProductPageMediaCache();
        if (typeof slider.afterAppend === 'function') {
          slider.afterAppend();
        }
        if (typeof slider.resetSlider === 'function') {
          slider.resetSlider(false, true);
        }
        slider.changeSlide(0, 'auto');
        if (slider.element) {
          slider.element.scrollLeft = 0;
        }
        if (typeof slider.checkSlide === 'function') {
          slider.checkSlide();
        }
        return;
      }

      refreshProductPageMediaCache();
    };

    const scheduleSliderResetToVariantSlide = () => {
      resetSliderToVariantSlide();
      window.requestAnimationFrame(() => resetSliderToVariantSlide());
      window.setTimeout(() => resetSliderToVariantSlide(), 120);
    };

    const updateVariantMediaSlot = (variant = productVariants.currentVariant) => {
      if (!variantMediaSlot) {
        return;
      }

      const imageState = getVariantImageState(variant);
      const image = variantMediaSlot.querySelector('.product-media-image');

      if (applyVariantMediaTemplate(variant)) {
        scheduleSliderResetToVariantSlide();
        return;
      }

      if (!imageState || !image) {
        return;
      }

      variantMediaSlot.dataset.mediaId = imageState.mediaId;
      ['src', 'srcset', 'width', 'height', 'alt'].forEach((attribute) => {
        if (imageState[attribute]) {
          image.setAttribute(attribute, imageState[attribute]);
        } else {
          image.removeAttribute(attribute);
        }
      });

      const zoomButton = variantMediaSlot.querySelector('product-image-zoom');
      if (zoomButton && imageState.src) {
        zoomButton.dataset.image = imageState.src;
      }

      scheduleSliderResetToVariantSlide();
    };

    const restoreFirstImageBadge = () => {
      if (!firstImageBadge || !firstImageBadgeParent || firstImageBadge.parentElement === firstImageBadgeParent) {
        return;
      }

      firstImageBadgeParent.insertBefore(firstImageBadge, firstImageBadgeNextSibling);
    };

    const moveFirstImageBadge = (targetMedia) => {
      if (!firstImageBadge || !targetMedia || firstImageBadge.parentElement === targetMedia) {
        return;
      }

      targetMedia.appendChild(firstImageBadge);
    };

    const promoteVariantMedia = (variant = productVariants.currentVariant) => {
      resetMediaOrder();
      updateVariantMediaSlot(variant);

      if (!isDesktopGridGallery()) {
        restoreFirstImageBadge();
        return;
      }

      const imageState = getVariantImageState(variant);
      const selectedMedia = variantMediaSlot || mediaItems.find((mediaItem) => imageState?.mediaId && mediaItem.dataset.mediaId === imageState.mediaId);
      if (!selectedMedia) {
        restoreFirstImageBadge();
        return;
      }

      selectedMedia.style.order = '-1';
      selectedMedia.classList.add('pxl-variant-media-first');
      moveFirstImageBadge(selectedMedia);
    };

    const scheduleMediaPromotion = (variant = productVariants.currentVariant, shouldFade = false) => {
      if (!isCurrentGalleryBinding()) {
        return;
      }

      window.clearTimeout(galleryPromotionTimeout);
      updateFlavorsPopupContent();

      if (shouldFade) {
        window.clearTimeout(galleryFadeTimeout);
        productGallery.classList.add('pxl-gallery-is-switching');
        galleryPromotionTimeout = window.setTimeout(() => promoteVariantMedia(variant), 90);
        galleryFadeTimeout = window.setTimeout(() => {
          productGallery.classList.remove('pxl-gallery-is-switching');
        }, 220);
        return;
      }

      promoteVariantMedia(variant);
      window.setTimeout(() => promoteVariantMedia(variant), 50);
    };

    productVariants.addEventListener('VARIANT_CHANGE', (event) => {
      if (!isCurrentGalleryBinding()) {
        return;
      }

      updateFlavorsPopupContent();
      scheduleMediaPromotion(event?.target?.currentVariant || getSelectedVariantFromInputs(), true);
    });

    productVariants.addEventListener('change', () => {
      if (!isCurrentGalleryBinding()) {
        return;
      }

      const refreshFromInputs = () => scheduleMediaPromotion(getSelectedVariantFromInputs(), true);
      refreshFromInputs();
      window.setTimeout(refreshFromInputs, 50);
      window.setTimeout(refreshFromInputs, 150);
    });

    productVariants.addEventListener('click', (event) => {
      if (!isCurrentGalleryBinding()) {
        return;
      }

      if (!event.target.closest('.product-variant__label, .product-variant__input, .product-variant__item')) {
        return;
      }

      const refreshFromInputs = () => scheduleMediaPromotion(getSelectedVariantFromInputs(), true);
      window.setTimeout(refreshFromInputs, 0);
      window.setTimeout(refreshFromInputs, 80);
      window.setTimeout(refreshFromInputs, 180);
    });

    const reinitializeGallery = () => {
      delete productPage.dataset.pxlGalleryInitialized;
      initPxlProductVariants(productPage);
    };

    const scheduleResizeRebind = () => {
      window.clearTimeout(resizeRebindTimeout);
      resizeRebindTimeout = window.setTimeout(() => {
        const nextGalleryMode = window.matchMedia('(max-width: 1023px)').matches ? 'slider' : 'grid';
        const nextSliderMarkupState = Boolean(productGallery.querySelector('.css-slider-container'));
        const shouldRebind = nextGalleryMode !== lastGalleryMode || nextSliderMarkupState !== lastSliderMarkupState;

        lastGalleryMode = nextGalleryMode;
        lastSliderMarkupState = nextSliderMarkupState;

        if (shouldRebind) {
          reinitializeGallery();
          return;
        }

        scheduleMediaPromotion(getSelectedVariantFromInputs());
      }, 180);
    };

    window.addEventListener('resize', () => {
      if (!isCurrentGalleryBinding()) {
        return;
      }

      scheduleResizeRebind();
    });

    updateFlavorsPopupContent();
    scheduleMediaPromotion();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPxlProductVariants());
} else {
  initPxlProductVariants();
}

document.addEventListener('shopify:section:load', (event) => {
  initPxlProductVariants(event.target);
});
